export default function () {
  const announcements = document.querySelectorAll(
    '.AnnouncementBar:not(.AnnouncementBar--page) .AnnouncementBar__Message',
  )
  const previousSeenIndexInStorage = localStorage.getItem('announcement')

  let currentAnnouncement
  let currentAnnouncementIndex = 0

  // If announcements are on the page

  if (announcements.length >= 1) {
    // If theres a previous index
    if (previousSeenIndexInStorage) {
      const previousSeenIndex = parseInt(previousSeenIndexInStorage)
      // is previous index higher or the same as the total
      if (previousSeenIndex >= announcements.length - 1) {
        currentAnnouncementIndex = 0
        currentAnnouncement = announcements.item(currentAnnouncementIndex)
      } else {
        // Otherwise add one on
        currentAnnouncementIndex = previousSeenIndex + 1
        currentAnnouncement = announcements.item(currentAnnouncementIndex)
      }
    } else {
      // Otherwise show the first
      currentAnnouncementIndex = 0
      currentAnnouncement = announcements.item(currentAnnouncementIndex)
    }

    // Show the Annoucments
    showAnnouncement(
      currentAnnouncement as HTMLElement,
      currentAnnouncementIndex,
    )
  }

  function showAnnouncement(announcement: HTMLElement, index: number) {
    announcement.style.display = 'flex' // Set the P to display block
    if (storageAvailable('localStorage')) {
      localStorage.setItem('announcement', index.toString()) // If Local Storage is avalible, update to new index
    }
  }

  // https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#testing_for_availability
  function storageAvailable(type: 'localStorage') {
    let storage
    try {
      storage = window[type]
      const x = '__storage_test__'
      storage.setItem(x, x)
      storage.removeItem(x)
      return true
    } catch (e) {
      return (
        e instanceof DOMException &&
        // everything except Firefox
        (e.code === 22 ||
          // Firefox
          e.code === 1014 ||
          // test name field too, because code might not be present
          // everything except Firefox
          e.name === 'QuotaExceededError' ||
          // Firefox
          e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
        // acknowledge QuotaExceededError only if there's something already stored
        storage &&
        storage.length !== 0
      )
    }
  }
}
